<template>
  <b-modal
    v-model="modalStatus"
    centered
    size="sm"
    button-size="sm"
    no-close-on-backdrop
  >
    <template #modal-header>
      <h5 class="modal-title">Edit Searchquery</h5>
      <button type="button" class="close" @click="closeModal()">×</button>
    </template>
    <b-alert v-model="hasUnknownError" variant="danger" fade>
      {{ unknownErrorMessage }}
    </b-alert>

    <b-alert v-model="hasError" variant="danger" fade>
      {{ errorMessage }}
    </b-alert>

    <validation-observer ref="observer" v-slot="{ passes }">
      <b-form @submit.prevent="passes(onSubmit)">
        <b-form-row>
          <b-col lg="12">
            <validation-provider vid="title" rules="required" v-slot="{ valid, errors, changed }">
              <b-form-input
                v-model="editingTemplate.title"
                type="text"
                :state="onValidateField(valid, errors, changed)"
                placeholder="Title"
              ></b-form-input>
              <b-form-invalid-feedback class="input-live-feedback">{{ errors[0] }}</b-form-invalid-feedback>
            </validation-provider>
          </b-col>
        </b-form-row>
        <div class="mt-2" v-if="existingNameAlert">
          this name is already in use
        </div>
        <b-row>
          <b-col lg="12" class="right">
            <b-button type="submit" variant="primary" size="sm" disabled v-if="isSubmitting" class="mt-4">
              <b-spinner small></b-spinner>
              Save
            </b-button>
            <b-button class="mt-4" type="submit" size="sm" variant="primary" ref="submitEditPlotBtn" v-else>Save</b-button>
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>
    <template #modal-footer>
      <div class="w-100">
        <b-button
          variant="secondary"
          size="sm"
          class="float-right"
          hidden
        >
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
  import { mapState } from 'vuex'
  import { ValidationObserver, ValidationProvider } from 'vee-validate'
  import { validateField } from '@/helpers/formHelper.js'

  const initialTemplate = () => ({
    editingTemplate: {
      field_001: null, /* eslint-disable-line */
      state: null,
      title: null,
      creator: null,
      deleted: null,
      table_type: null
    }
  })

  export default {
    name: 'edit-template-searchquery',
    components: {
      ValidationObserver,
      ValidationProvider
    },
    data () {
      return {
        isSubmitting: false,
        hasUnknownError: false,
        unknownErrorMessage: '',
        hasError: false,
        errorMessage: '',
        modalAlert: false,
        existingNameAlert: false,
        ...initialTemplate()
      }
    },
    methods: {
      loadData (templateData) {
        Object.assign(this.editingTemplate, templateData)
      },
      onSubmit () {
        this.checkTemplateByTitle()
      },
      async checkTemplateByTitle () {
        try {
          const { errors } = await this.$store.dispatch('template/GET_TEMPLATE_BY_TITLE', {
            formData: this.editingTemplate
          })
          if (!errors) {
            if (this.matchingTemplates.length) {
              this.existingNameAlert = true
            } else {
              this.existingNameAlert = false
              this.editTemplate()
            }
          } else {
            throw errors
          }
        } catch (err) {
          this.hasError = true
          this.errorMessage = this.$t('formError.unknownwError')
          setTimeout(() => {
            this.hasError = false
          }, 5000)
          console.error(err)
        }
      },
      async editTemplate () {
        try {
          const { errors } = await this.$store.dispatch('template/EDIT_TEMPLATE', {
            formData: this.editingTemplate
          })
          if (!errors) {
            this.$store.commit('template/SET_EDIT_SEARCHQUERY_STATUS', false)
            this.getTemplatesSearchquery()
          } else {
            throw errors
          }
        } catch (err) {
          this.hasError = true
          this.errorMessage = this.$t('formError.unknownwError')
          setTimeout(() => {
            this.hasError = false
          }, 5000)
          console.error(err)
        }
      },
      async getTemplatesSearchquery () {
        try {
          const { errors } = await this.$store.dispatch('template/GET_TEMPLATES_SEARCHQUERY')
          if (!errors) {
            this.reset()
          } else {
            throw errors
          }
        } catch (err) {
          this.hasError = true
          this.errorMessage = this.$t('formError.unknownwError')
          setTimeout(() => {
            this.hasError = false
          }, 5000)
          console.error(err)
        }
      },
      closeModal () {
        this.$store.commit('template/SET_EDIT_SEARCHQUERY_STATUS', false)
        this.reset()
        this.existingNameAlert = false
      },
      reset () {
        Object.assign(this.$data, initialTemplate())
      },
      onValidateField (valid, errors, changed) {
        return validateField(valid, errors, changed)
      }
    },
    computed: {
      ...mapState({
        modalStatus: state => state.template.editQuerySearchStatus,
        matchingTemplates: state => state.template.matchingTemplates
      })
    }
  }
</script>
